/**
 * Medications workspace — the unified medications UI (GDN-2351 Component E).
 *
 * Graduated presentational components live in components/; the pure display
 * layer (view-model types + formatters + unified-response mapper) in vm/;
 * per-surface data glue in containers/. proposals/ is the remaining design
 * archive and is intentionally not exported here.
 *
 * NOTE: stories must import via direct file paths, not this barrel — the
 * autoRegisterFeature call below is a module-load side effect.
 */

import { autoRegisterFeature } from '@store/features/factory';

import { medicationsWorkspaceFeature } from './store/feature';

autoRegisterFeature(medicationsWorkspaceFeature);

// Containers (per-surface data glue)
export { UnifiedMedicationPeek } from './containers/UnifiedMedicationPeek';
export { V1AllergiesCard } from './containers/V1AllergiesCard';
export { V1DiagnosesCard } from './containers/V1DiagnosesCard';
export { V1MedicationsCard } from './containers/V1MedicationsCard';
export { V1UnifiedClinicalCards } from './containers/V1UnifiedClinicalCards';

// Store (friendly hook names only)
export * from './store';

// Presentational components (VM-in → UI-out)
export { AllergyPeekList } from './components/AllergyPeekList';
export { ClinicalCardActions } from './components/ClinicalCardActions';
export { ClinicalCardFrame } from './components/ClinicalCardFrame';
export { DiagnosisPeekList } from './components/DiagnosisPeekList';
export { MedicationHistorySection } from './components/MedicationHistorySection';
export { MedicationPeekList } from './components/MedicationPeekList';
export { MedicationRow } from './components/MedicationRow';
export { MedicationsCard } from './components/MedicationsCard';
export { MedicationTable } from './components/MedicationTable';
export { PastPrescriptionRow } from './components/PastPrescriptionRow';
export { RowActionsMenu } from './components/RowActionsMenu';

// Wire-row → VM mappers (context bar maps its /info rows through these)
export type { AllergyRow, DiagnosisRow } from './vm/mapClinicalToVM';
export { mapAllergiesToVM, mapDiagnosesToVM } from './vm/mapClinicalToVM';
export type * from './vm/types';
